import React from 'react';
import {
  Grid,
  Typography,
  FormHelperText,
  FormControlLabel,
} from '@material-ui/core';
import { useFormikContext, ErrorMessage } from 'formik';
import MultiOptionField from 'components/MultiOptionField';
import CustomCheckbox from 'components/CustomCheckbox';
import { IExpandedMailingRule } from 'interfaces/MailingRule';
import { IMailingRuleSubformProps } from '../../interfaces';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { IOptionData } from 'interfaces/utils';

const SystemsField: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    initialValues,
  } = useFormikContext<IExpandedMailingRule>();

  const {
    list: {
      mailingRuleSystemFields,
      mailingRuleSubSystemOptionBySystem,
      mailingRuleSubSystemValuesOrderBySystem,
    },
  } = useSelector((state: RootState) => state.parameters);
  const toggleSelectAllSystems = () => {
    if (Object.values(values.systems).some((items) => !!items.length)) {
      setFieldValue('systems', initialValues.systems);
    } else {
      setFieldValue('systems', mailingRuleSubSystemValuesOrderBySystem);
    }
  };

  const areAllSelected = Object.entries(
    values.systems,
  ).every(([system, selected]) =>
    mailingRuleSubSystemValuesOrderBySystem[system].every((s: string) =>
      selected.includes(s),
    ),
  );

  const isErrored =
    touched.systems && errors.systems && typeof errors.systems === 'string';

  return (
    <Grid
      data-cy="system-fields__custom-options--system-fields"
      item
      xs={12}
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <Grid item xs={12}>
        <Typography variant="h6">Sistemas</Typography>
      </Grid>
      <Grid item xs={12}>
        <FormHelperText error>
          <ErrorMessage name="systems" />
        </FormHelperText>
      </Grid>
      <Grid item xs={2}>
        <FormControlLabel
          control={
            <CustomCheckbox
              checked={areAllSelected}
              onChange={toggleSelectAllSystems}
              error={isErrored}
            />
          }
          label={
            <Typography style={{ fontWeight: 'bold' }}>
              Todos os Sistemas
            </Typography>
          }
          disabled={!isEditable}
        />
      </Grid>
      {mailingRuleSystemFields.map((systemField) => (
        <Grid key={systemField} item>
          <MultiOptionField
            isErrored={isErrored}
            name={`systems.${systemField}`}
            hasSelectAll={systemField !== 'tv'}
            selectAllLabel={
              mailingRuleSubSystemOptionBySystem[systemField].label
            }
            options={
              mailingRuleSubSystemOptionBySystem[systemField]
                .fieldOptions as IOptionData[]
            }
            indeterminateIfAny
            disabled={!isEditable}
            highLightFirstLabel={true}
            direction="row"
            shrunk={systemField === 'movel'}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default SystemsField;
